import React from 'react';
import IconWrapper from '../IconWrapper';
const HazmatWarningIcon = (props) => (React.createElement(IconWrapper, Object.assign({}, props, { viewBox: "-13 -14 28 28" }),
    React.createElement("path", { d: "M9.9-5.1L1-14-13 0 1 14 15 0 9.9-5.1zm-16 10.2L-11.2 0l5.1-5.1H8.1L13.2 0 8.1 5.1H-6.1z" })));
export default HazmatWarningIcon;
//# sourceMappingURL=HazmatWarningIcon.js.map